import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { StatementsFacade } from '@app/modules/statements/services/statements.facade';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sbnb-dialog-new-owner',
  templateUrl: './dialog-new-owner.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogNewOwnerComponent {
  public owner = this.statementsFacade.newOwner();
  public savingOwner$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly statementsFacade: StatementsFacade,
    private readonly dialogRef: MatLegacyDialogRef<DialogNewOwnerComponent>
  ) {}

  public saveOwner(): void {
    this.savingOwner$.next(true);
    this.statementsFacade.createOwner(this.owner).subscribe((owner) => {
      this.statementsFacade.getOwners();
      this.savingOwner$.next(false);
      this.close();
    });
  }

  public close(): void {
    this.dialogRef.close();
  }
}
